import React from 'react';
import LoginForm from './LoginForm';
import { Link } from 'react-router-dom';
import singlePageStyles from '../common/SinglePage.module.scss';
import Layout from '../global/Layout';
import { Trans, useTranslation } from 'react-i18next';

const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Layout>
      <div className={singlePageStyles.wrapper}>
        <h1>{t('pages.login.title')}</h1>
        <LoginForm />

        <div className={singlePageStyles.otherActions}>
          <Link to='/forgot-password'>{t('pages.login.otherActions.forgotPassword')}</Link>
          <Link to='/register'>{t('pages.login.otherActions.register')}</Link>
        </div>
      </div>
    </Layout>
  );
};

export default LoginPage;
